import { render, staticRenderFns } from "./AssetView.vue?vue&type=template&id=856acc9a&"
import script from "./AssetView.vue?vue&type=script&lang=js&"
export * from "./AssetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports